import type { JobSalary } from "./JobSalary.model";

export interface MetroArea {
  id: string;
  title: string;
}

export interface Quantile {
  id: string;
  title: string;
  short: string;
}

export namespace WatchlistFiltersUtils {
  export const getUniqueFilters = (data: JobSalary[], key: keyof JobSalary) => {
    const uniqueValues = [...new Set(data?.map((item) => item[key]))];
    return uniqueValues.map((value) => ({
      id: value,
      name: value,
    }));
  };
}
